import { Component, OnInit, Output, EventEmitter, Input, ElementRef, AfterViewInit, ViewChild, OnChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mc-next-back-btn',
  templateUrl: './next-back-btn.component.html',
  styleUrls: ['./next-back-btn.component.scss']
})
export class NextBackBtnComponent implements OnInit, OnChanges {

  @Output() onCancelEvent: EventEmitter<any>;
  @Output() onNextEvent: EventEmitter<any>;
  @Output() onSaveDraftEvent: EventEmitter<any>;
  @Input() isDisableNextBtn: boolean;
  @Input() isBackground: boolean
  @ViewChild('nextBackBtnContainer') nextBackBtnContainer!: ElementRef;
  private calFn: any;
  private tagBody!: HTMLElement;
  public isAbsoluteBottom: boolean;
  constructor(
    private elRef: ElementRef
  ) {
    this.onCancelEvent = new EventEmitter<any>();
    this.onNextEvent = new EventEmitter<any>();
    this.onSaveDraftEvent = new EventEmitter<any>();
    this.isDisableNextBtn = false;
    this.isBackground = true;
    this.isAbsoluteBottom = true;
  }

  private fixNextBackContainerPosition(){
    const windowHeight = window.innerHeight;
    const contentHeight = document.documentElement.offsetHeight;
    this.isAbsoluteBottom = contentHeight + this.nextBackBtnContainer.nativeElement.offsetHeight < windowHeight;
    if (this.isAbsoluteBottom) {
      this.nextBackBtnContainer.nativeElement.className = 'row columns align-middle align-spaced next-back-btn-container is-background is-absolute'
    }else{
      this.nextBackBtnContainer.nativeElement.className = 'row columns align-middle align-spaced next-back-btn-container is-background'
    }
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.isAbsoluteBottom = false;
  }

  ngAfterViewInit() {
    //this.fixNextBackContainerPosition();
  }

  ngOnChanges() {
    //this.fixNextBackContainerPosition();
  }
}
